import "./insCreateTags.scss";
import { AuxTextInput } from "@blk/aladdin-react-components-es";
import { createSelector } from "@reduxjs/toolkit";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { language } from "language/default";
import { setTagColor, setTagName } from "store/tags";
export const possibleTagColors = [
    "#FFF479",
    "#FFDB75",
    "#C9F470",
    "#FF9364",
    "#EF6CE5",
    "#CB9FFA",
    "#6EF7E0",
    "#69C0FA"
];
const createTagStateSelector = createSelector((state) => state.createTag, (tagState) => tagState);
export const InsCreateTagContent = () => {
    const dispatch = useDispatch();
    const { tagName, tagColor } = useSelector(createTagStateSelector);
    return React.createElement("div", { className: "createTag_content" },
        language.en.modal.portfolioCreation.portfolioTagCreation.tagName,
        React.createElement(AuxTextInput, { className: "addPadding", onFormValueChanged: (e) => dispatch(setTagName(e.detail.value)), placeholder: language.en.modal.portfolioCreation.portfolioTagCreation.tag, value: tagName }),
        language.en.modal.portfolioCreation.portfolioTagCreation.selectColor,
        React.createElement("div", { className: "colorOptions" }, possibleTagColors.map((color, index) => React.createElement("div", { key: index, className: `colorOption${tagColor === color ? " selected" : ""}`, onClick: () => dispatch(setTagColor(color)), style: { backgroundColor: color } }))));
};
